import {publicImageUrl} from 'organization/ImageSelector'
import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {
  pathSegments,
  stripLocaleFromSegments,
  segmentAfter,
} from 'i18n/localePaths'

export function usePathWithoutLocale(): string {
  const location = useLocation()
  const stripped = stripLocaleFromSegments(pathSegments(location.pathname))
  return stripped.length ? `/${stripped.join('/')}` : '/'
}

export function useRouteOrganizationId() {
  const location = useLocation()
  const segs = stripLocaleFromSegments(pathSegments(location.pathname))
  const id = segmentAfter(segs, 'organization')
  if (!id) {
    return null
  }
  const n = parseInt(id, 10)
  return Number.isFinite(n) ? n : null
}

export function useIsInOrganizationRoutes() {
  const segs = stripLocaleFromSegments(pathSegments(useLocation().pathname))
  return segs[0] === 'organization'
}

export function useURLHasOrganizationID() {
  const segs = stripLocaleFromSegments(pathSegments(useLocation().pathname))
  if (segs[0] !== 'organization') {
    return false
  }
  const id = segs[1]
  if (!id) {
    return false
  }
  const n = parseInt(id, 10)
  return Number.isFinite(n) && n > 0
}

export function useRouteOrganizationEventId() {
  const segs = stripLocaleFromSegments(pathSegments(useLocation().pathname))
  const id = segmentAfter(segs, 'event')
  if (!id) {
    return null
  }
  const n = parseInt(id, 10)
  return Number.isFinite(n) ? n : null
}

export function useRouteOrganizationAtendantId() {
  const segs = stripLocaleFromSegments(pathSegments(useLocation().pathname))
  const i = segs.findIndex((s) => s === 'attendant')
  if (i < 0 || !segs[i + 1]) {
    return null
  }
  const n = parseInt(segs[i + 1], 10)
  return Number.isFinite(n) ? n : null
}

export type QueryParams = Record<string, string | undefined>

export function useQueryParams() {
  const {search} = useLocation()

  return useMemo(() => {
    const params = new URLSearchParams(search)

    const result: QueryParams = {}

    for (const [key, val] of params.entries()) {
      result[key] = val
    }

    return result
  }, [search])
}

export function publicUrl(url?: string | null) {
  return publicImageUrl(url)
}
